import {
  RESET_PASSWORD,
  CHANGE_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
} from "./actionTypes"

export const userResetPassword = (data, history) => {
  return {
    type: RESET_PASSWORD,
    payload: { data, history },
  }
}

export const userChangePassword = (data) => {
  return {
    type: CHANGE_PASSWORD,
    payload: {data},
  }
}

export const userResetPasswordSuccess = message => {
  return {
    type: RESET_PASSWORD_SUCCESS,
    payload: message,
  }
}

export const userResetPasswordError = message => {
  return {
    type: RESET_PASSWORD_ERROR,
    payload: message,
  }
}
